<template>
  <section class="conclusion-wrap" v-parallax ref="conclusion">
    <v-preface-conclusion
      :data="pageDataItem.page0.data"
      bg="images/conclusion/bg.jpg"
      :name="$TL.episode8"
    />
  </section>
</template>

<script>
import { mapState } from "vuex";
import { timeout } from "utils/util";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {};
  },
  created() {
    this.pageDataItem = this.schema["conclusion"].item;
    timeout(1500).then(() => {
      this.$refs.conclusion.classList.add("fade");
    });
  },
};
</script>
<style lang="scss">
.conclusion-wrap {
  .content-box {
    transition: opacity 1s ease;
    opacity: 0;
  }

  &.fade {
    .content-box {
      opacity: 1;
    }
  }
}

body.ie11 {
  .v-preface-conclusion {
    .v-background {
      position: fixed;
      top: 0;
      left: 0;

      img {
        width: 100vw;
        height: 100vh;
      }
    }

    .v-fade-out-in {
      width: 100vw;
      height: 100vh;
    }
  }
}
</style>
>
